import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatbotGenericMessage } from '../models/chatbot-generic-message';
import { ChatbotMessages } from '../models/chatbot-message';

@Component({
  selector: 'pt-chatbot-generic-message',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="message-container message-center">
      <div class="d-flex flex-row" style="margin-bottom: -4px">
        <span class="font-10 me-1">{{ msg.user }}</span>
        <span class="font-10">{{ msg.timestamp | date:'dd/MM/yyyy HH:mm' }}</span>
      </div>
      <span class="message" *ngIf="msg.payload.message" [innerHTML]="msg.payload.message | async"></span>
    </div>
  `,
  styleUrls: [`pt-chatbot-message.css`]
})
export class PtChatbotGenericMessageComponent {
  @Input() msg!: ChatbotMessages<ChatbotGenericMessage>;
}
